import * as angular from "angular";
import {IController} from "angular";

export class bringozServiceAttachmentsCtrl implements IController {

  attachments: any;
  attachmentsUrls: any;
  onAddAttachment: Function;
  onRemoveAttachment: Function;

  /* @ngInject */
  constructor() {}
}

angular
  .module('bringoz.admin.deliveries')
  .component('bringozServiceAttachments', {
    bindings: {
      attachments: '<',
      attachmentsUrls: '<?',
      onAddAttachment: '&',
      onRemoveAttachment: '&'
    },
    template: require('./bringoz-service-attachments.html').default,
    controller: bringozServiceAttachmentsCtrl
  });
